import React, {PureComponent} from 'react';
import classNames from 'classnames';
import Icon from '../../Icon';

class MinusButton extends PureComponent {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.remove(this.props.index);
    }

    render() {
        const {children, className} = this.props;

        return (
            <button className={classNames(className, 'plus-button btn')} type="button" onClick={this.handleClick}>
                <Icon icon="remove" />
                {children && <span className="ml-1">{children}</span>}
            </button>
        );
    }
}

export default MinusButton;
